import { useEffect, useState } from "react";
import i18n from "../../i18n";
import Select from "react-tailwindcss-select";
import EnFlag from "../../icons/ENFlag";
import SaFlag from "../../icons/SAFlag";
import FrFlag from "../../icons/FRFlag";
import DeFlag from "../../icons/DEFlag";
import TrFlag from "../../icons/TRFlag";

export default function ChangeLang({ menuClassName = "" }) {
  const options = [
    { value: "en", label: "EN", flag: EnFlag },
    { value: "ar", label: "AR", flag: SaFlag },
    { value: "fr", label: "FR", flag: FrFlag },
    { value: "de", label: "DE", flag: DeFlag },
    { value: "tr", label: "TR", flag: TrFlag },
  ];

  const [lang, setLang] = useState(i18n.language || "en");

  useEffect(() => {
    document.dir = lang === "ar" ? "rtl" : "ltr";
    document.body.classList.remove("rtl", "ltr");
    document.body.classList.add(lang === "ar" ? "rtl" : "ltr");
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  }, [lang]);

  const onLangChange = (selected) => {
    const newLang = selected.value;
    setLang(newLang);
  };

  return (
    <Select
      onChange={onLangChange}
      value={options.find((option) => option.value === lang)}
      options={options}
      placeholder={lang.toUpperCase()}
      classNames={{
        listItem: () => "",
        menu: "shadow-lg border rounded-sm absolute w-full bg-white dark:bg-[#1F2937] border-gray-100 dark:border-gray-600",
        menuButton: () =>
          `flex items-center justify-between cursor-pointer font-semibold h-11 w-[70px] px-1 
           border border-gray-200 dark:border-gray-600 
           bg-white dark:bg-[#111827] 
           text-black dark:text-white 
           placeholder-gray-300 dark:placeholder-gray-400 
           rounded-md ${menuClassName}`,
      }}
      formatOptionLabel={(data) => {
        const Flag = data.flag;
        return (
          <li
            className="flex items-center justify-between w-full gap-2 p-2 text-base font-semibold transition-all 
            rounded-sm cursor-pointer hover:bg-[#F9F8FE] dark:hover:bg-gray-700 
            hover:text-mainRed dark:hover:text-white"
          >
            <Flag className={"rounded-full"} />
            <span>{data.label}</span>
          </li>
        );
      }}
    />
  );
}
